import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "api/axios.config";

const TASKS_BASE = "/Tasks";

const buildOrderBy = (sort) => {
  if (!sort) return "dateDueBy desc";
  return sort.dir === "desc" ? `${sort.field} desc` : sort.field;
};

const buildQuery = ({
  page,
  limit,
  sort,
  branchId,
  teamId,
  createdBy,
  feeEarnerRef,
  fD,
  tD,
  status,
  searchValue,
}) => {
  const params = new URLSearchParams();
  params.append("active", "true");
  if (page) params.append("Page", page);
  if (limit) params.append("Limit", limit);
  params.append("OrderBy", buildOrderBy(sort));
  if (branchId && branchId > 0) params.append("BranchId", branchId);
  if (teamId && teamId > 0) params.append("TeamId", teamId);
  if (createdBy && createdBy !== "ALL") params.append("CreatedBy", createdBy);
  if (feeEarnerRef && feeEarnerRef !== "ALL")
    params.append("FeeEarnerRef", feeEarnerRef);
  if (fD) params.append("FromDate", fD);
  if (tD) params.append("ToDate", tD);
  if (status !== undefined && status !== null && status !== "")
    params.append("Status", status);
  if (searchValue) params.append("Search", searchValue);
  return params.toString();
};

export const fetchTasksList = createAsyncThunk(
  "tasksList/fetchList",
  async (args) => {
    if (args.page === undefined) return undefined;
    const res = await API.get(`${TASKS_BASE}?${buildQuery(args)}`);
    return res.data;
  },
);

export const fetchTasksSummary = createAsyncThunk(
  "tasksList/fetchSummary",
  async (args) => {
    const res = await API.get(`${TASKS_BASE}/Summary?${buildQuery(args)}`);
    return res.data?.data || res.data;
  },
);

const initialState = {
  tasksList: undefined,
  summary: { totalTasks: 0, totalDue: 0, totalOverdue: 0, totalCompleted: 0 },
  isLoading: false,
  isSummaryLoading: false,
};

const tasksSlice = createSlice({
  name: "tasksList",
  initialState,
  reducers: {
    clearTasksList: (state) => {
      state.tasksList = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTasksList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchTasksList.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload === undefined) {
          state.tasksList = undefined;
          return;
        }
        state.tasksList = action.payload;
      })
      .addCase(fetchTasksList.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(fetchTasksSummary.pending, (state) => {
        state.isSummaryLoading = true;
      })
      .addCase(fetchTasksSummary.fulfilled, (state, action) => {
        state.isSummaryLoading = false;
        if (action.payload) state.summary = action.payload;
      })
      .addCase(fetchTasksSummary.rejected, (state) => {
        state.isSummaryLoading = false;
      });
  },
});

export const { clearTasksList } = tasksSlice.actions;
export const tasksReducer = tasksSlice.reducer;
export default tasksReducer;
